<template>
  <div>
    <el-dialog 
      :title="title" 
      :visible="localVisible" 
      width="900px" 
      @close="onClose"
      :close-on-click-modal="false"
      class="alipay-dialog"
    >
      <div class="dialog-content">
        <!-- 搜索栏 -->
        <div class="search-bar">
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-input 
                v-model="keywords" 
                placeholder="请输入机构名称"
                prefix-icon="el-icon-search"
                clearable
                class="search-input"
                @keyup.enter.native="chooseItem"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="chooseItem" icon="el-icon-search">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="resetSearch" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格 -->
        <div class="table-wrapper">
          <el-table
            ref="multipleTable"
            :data="mList"
            height="350"
            stripe
            border
            size="medium"
            :header-cell-style="headerCellStyle"
            @row-click="handleRowClick"
            v-loading="loading"
            element-loading-text="加载中..."
          >
            <el-table-column label="选择" width="60" align="center">
              <template slot-scope="scope">
                <el-radio 
                  v-model="curShop" 
                  :label="scope.row" 
                  @input="clickChange(scope.row, scope.$index)"
                >{{ "" }}</el-radio>
              </template>
            </el-table-column>
            
            <el-table-column
              label="机构编码"
              width="120"
              prop="sn"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span class="sn-text">{{ scope.row.sn || '-' }}</span>
              </template>
            </el-table-column>
            
            <el-table-column
              label="机构名称"
              min-width="180"
              prop="name"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <div class="name-cell">
                  <i class="el-icon-shop"></i>
                  <span>{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="机构类别"
              width="150"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-tag size="small" type="primary" effect="plain">
                  <i class="el-icon-folder"></i>
                  {{ scope.row.category ? scope.row.category.name : '-' }}
                </el-tag>
              </template>
            </el-table-column>
            
            <el-table-column
              label="机构地址"
              min-width="200"
              prop="address"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <div class="address-cell" v-if="scope.row.address">
                  <i class="el-icon-location"></i>
                  <span>{{ scope.row.address }}</span>
                </div>
                <span v-else class="empty-text">-</span>
              </template>
            </el-table-column>
            
            <el-table-column
              label="联系电话"
              width="140"
              prop="mobile"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <div class="mobile-cell" v-if="scope.row.mobile">
                  <i class="el-icon-phone"></i>
                  <span>{{ scope.row.mobile }}</span>
                </div>
                <span v-else class="empty-text">-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 空状态 -->
        <div v-if="mList.length === 0 && !loading" class="empty-state">
          <i class="el-icon-folder-opened"></i>
          <p>暂无机构数据</p>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrapper" v-if="total > 0">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :pager-count="5"
          >
          </el-pagination>
        </div>

        <!-- 底部按钮 -->
        <div class="dialog-footer">
          <el-button size="medium" @click="close" icon="el-icon-close">取消</el-button>
          <el-button size="medium" type="primary" @click="ok" icon="el-icon-check">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'eShopList',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "选择机构",
    },
    closeForm: {
      type: Function,
      default: () => {}
    },
  },
  data() {
    return {
      localVisible: false,
      loading: false,
      index: '',
      curShop: null,
      id: '',
      name: '',
      keywords: '',
      fileList: [],
      mList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      item: {}
    }
  },
  mounted() {
    this.DataList()
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    
    // 重置搜索
    resetSearch() {
      this.keywords = ''
      this.pageNum = 1
      this.DataList()
      this.$message.success('已重置搜索条件')
    },
    
    // 点击行选中
    handleRowClick(row, index) {
      this.curShop = row
      this.index = index
      this.id = row.id
      this.name = row.name
      this.item = row
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    onClose() {
      this.$emit('update:visible', false)
      if (this.closeForm) {
        this.closeForm()
      }
    },
    
    close() {
      this.$emit('update:visible', false)
      if (this.closeForm) {
        this.closeForm()
      }
    },
    
    ok() {
      if (!this.id) {
        this.$message.warning('请选择一家机构')
        return
      }
      this.$emit('eventChoose', this.id, this.name, this.item)
      this.$emit('update:visible', false)
      if (this.closeForm) {
        this.closeForm()
      }
    },
    
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        page: this.pageNum,
        pageSize: this.pageSize,
      }
      
      if (this.keywords && this.keywords.trim() !== '') {
        param.name = this.keywords.trim()
      }
      
      this.$axios.shopListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.mList = res.data.data || []
          this.total = res.data.total || 0
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
        this.$message.error('加载数据失败')
      })
    },
    
    clickChange(row, index) {
      this.index = index
      this.id = row.id
      this.name = row.name
      this.item = row
    },
    
    chooseItem() {
      this.pageNum = 1
      this.DataList()
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val
      if (val) {
        // 弹框打开时刷新数据
        this.pageNum = 1
        this.keywords = ''
        this.DataList()
        this.curShop = null
        this.id = ''
        this.name = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// 弹框样式
.alipay-dialog {
  ::v-deep .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    
    .el-dialog__header {
      background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
      padding: 16px 20px;
      
      .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
      
      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 18px;
        
        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
    
    .el-dialog__body {
      padding: 0;
    }
  }
}

.dialog-content {
  padding: 20px 24px 24px;
}

// 搜索栏样式
.search-bar {
  background: #f8f9fc;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .el-form-item {
    margin-bottom: 0;
  }
  
  .search-input {
    width: 280px;
  }
  
  .search-input ::v-deep .el-input__inner {
    border-radius: 20px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    border-radius: 20px;
    padding: 8px 20px;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
  
  .el-button:not(.el-button--primary) {
    border-radius: 20px;
    padding: 8px 20px;
  }
}

// 表格样式
.table-wrapper {
  margin-bottom: 16px;
  border-radius: 12px;
  overflow: hidden;
  
  ::v-deep .el-table {
    border-radius: 12px;
    overflow: hidden;
    
    &::before {
      display: none;
    }
    
    th {
      background: #fafbfc !important;
      font-weight: 500;
    }
    
    td {
      border-bottom: 1px solid #f0f0f0;
    }
    
    .el-table__row {
      transition: background 0.2s;
      cursor: pointer;
      
      &:hover {
        background: #f8f9fc;
      }
    }
    
    .el-radio__input.is-checked .el-radio__inner {
      background-color: #1677ff;
      border-color: #1677ff;
    }
  }
}

.sn-text {
  font-family: monospace;
  font-size: 12px;
  color: #1677ff;
  font-weight: 500;
}

.name-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    font-size: 14px;
    color: #00b578;
  }
  
  span {
    font-weight: 500;
    color: #1f2d3d;
  }
}

.address-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  
  i {
    font-size: 12px;
    color: #e6a23c;
  }
  
  span {
    font-size: 12px;
    color: #606266;
  }
}

.mobile-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  
  i {
    font-size: 12px;
    color: #1677ff;
  }
  
  span {
    font-size: 12px;
    color: #606266;
  }
}

.empty-text {
  color: #c0c4cc;
  font-size: 12px;
}

// 空状态样式
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #c0c4cc;
  
  i {
    font-size: 64px;
  }
  
  p {
    margin-top: 16px;
    font-size: 14px;
  }
}

// 分页样式
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0;
  border-top: 1px solid #f0f0f0;
  
  ::v-deep .el-pagination {
    .el-pager li.active {
      background: #1677ff;
      color: #fff;
    }
    
    .el-pagination__total {
      color: #8c8f98;
    }
  }
}

// 底部按钮样式
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  margin-top: 8px;
  
  .el-button {
    border-radius: 20px;
    padding: 9px 24px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}

// 响应式调整
@media (max-width: 768px) {
  .dialog-content {
    padding: 16px;
  }
  
  .search-bar .search-input {
    width: 200px;
  }
}
</style>